import { gradeMappingCodec, type GradeMappingSchema } from '@repo/schemas/grade-scale/gradeScale';

import type { GradeBand } from './gradeScale.types';

/**
 * Bands of a stored mapping, or null when there are none to show. Snapshots
 * outlive the scale rules, so a mapping may no longer satisfy them (fewer than
 * two thresholds, none starting at 0); such a mapping is treated as absent
 * rather than throwing.
 */
export function getMappingBands(mapping: GradeMappingSchema | null | undefined): GradeBand[] | null {
  if (!mapping) {
    return null;
  }
  const result = gradeMappingCodec.safeEncode(mapping);
  return result.success ? result.data : null;
}

/**
 * The span a grade band covers, in percentage points. Equals the distance
 * from the previous band's upper bound (0 for the first band) to this band's
 * upper bound, matching the "Rozpiętość" column in the design.
 */
export function getBandSpan(bands: GradeBand[], index: number): number {
  const band = bands[index];
  if (!band) return 0;
  const previousMax: number = bands[index - 1]?.maxPercent ?? 0;
  return band.maxPercent - previousMax;
}
